import { Component, OnInit,HostListener,LOCALE_ID, AfterViewInit, OnDestroy, EventEmitter, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { TranslateService } from "@ngx-translate/core";
import { UserDetailsService } from '../../services/user-details.service';
import { AjaxService } from '../../services/ajax.service';
import { Utility } from '../../shared/utility/utility';
import { CustomValidators } from '../../shared/utility/custom-validator';
import { EmitterService } from '../../services/emitter.service';
import { ProfileSettingService } from '../../services/profile-setting.service';
import { MyaccountSharedComponent } from '../myaccount-shared/myaccount-shared.component';
import * as $ from 'jquery';
window['$'] = window['jQuery'] = $;
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";

@Component({
  selector: 'app-bet-history',
  templateUrl: './bet-history.component.html',
  providers:[
    {
      provide: LOCALE_ID,
      deps: [UserDetailsService],      //some service handling global settings
      useFactory: (userDetailsService) => userDetailsService.getLanguage()  //returns locale string
    }],
  styleUrls: ['./bet-history.component.scss']
})
export class BetHistoryComponent extends MyaccountSharedComponent implements OnInit, AfterViewInit , OnDestroy{

  betHistory:any;
  userId:any;
  maxDate = new Date();
  request: any = {};
  totalBalance;
  cashBalance;
  bonusBalance;
  txnTypes;
  mobiDatePicker;
  userDetail;
  startdate;
  enddate;
  serverError;
  windowType;
  langCode;
  noOfTransactions=11;
  noOfNewTransactions=10;
  destroy$: Subject<boolean> = new Subject<boolean>();
  @Output() triggerAccountMenu = new EventEmitter<{}>();

  @HostListener('window:resize') onResize() {
    /*Guard against resize before view is rendered*/
    const ww = document.body.clientWidth;
    if(ww <= 767){
      this.windowType = "mobile";
    }else{
      this.windowType = "device";
    }
  }
  betHistoryDetails = this.formBuilder.group({
    'startDate': ['', [this.customValidators.required]],
    'endDate': ['', [this.customValidators.required]],
    'items': ['10', [this.customValidators.required]]
  });
  // { validator: this.customValidators.startEndDateCheck } // Validation not required as one date auto changes when the other is changed



  constructor(private ajaxService : AjaxService,
    private utils:Utility,
    private formBuilder:FormBuilder,
    public userDetails:UserDetailsService,
    public datePipe: DatePipe,
    private customValidators: CustomValidators,
    private emitterService: EmitterService,
    private router: Router,
    private profileSettingService:ProfileSettingService,
    private translationService:TranslateService,
    private myaccountSharedComponent : MyaccountSharedComponent
  ) {
    super(utils);
    this.langCode = localStorage.getItem('langCode');
    this.emitterService.langCodeSource$.pipe(takeUntil(this.destroy$)).subscribe(langCode => {
      this.langCode = langCode;
    });
    this.userDetails.userBalanceUpdated$.pipe(takeUntil(this.destroy$)).subscribe(message => {
      this.totalBalance=this.userDetails.getUserBalanceDetails();
      this.cashBalance= this.userDetails.getUserCashBalance().toFixed(2).toString();
      this.bonusBalance=this.userDetails.getUserBonusBalance().toFixed(2).toString();
    });
    MyaccountSharedComponent.formgroup = this.betHistoryDetails;
  }

  ngOnInit() {
    if(!this.utils.isUserLoggedIn()){
      this.router.navigate([this.langCode+'/login']);
    }
    this.emitterService.broadcastActiveTabChangeSource("betHistory");
    this.totalBalance=this.userDetails.getUserBalanceDetails();
    this.cashBalance= this.userDetails.getUserCashBalance().toFixed(2).toString();
    this.bonusBalance=this.userDetails.getUserBonusBalance().toFixed(2).toString();
    let date = new Date();
    this.startdate = new Date(date.setDate(date.getDate() - 7));
    this.enddate = new Date();
    this.request={
      interval: {
        start: this.startdate,
        end: this.enddate,
      },
      size:this.noOfTransactions,
      index:0,
      type:"betHistory"
    }
    this.getTransactionDetails(this.request,"");
    Promise.resolve(this.profileSettingService.getProfileData(false)).then(profileData => {
      this.userDetail = this.userDetails.getUserProfileDetails();
    });
  }
  ngAfterViewInit() {
    setTimeout(() => {
      this.windowType = document.body.clientWidth <= 767 ? "mobile" : "device";
      this.betHistoryDetails.controls["startDate"].setValue(this.startdate);
      this.betHistoryDetails.controls["endDate"].setValue(this.enddate);
      this.betHistoryDetails.controls["items"].setValue("10");
      MyaccountSharedComponent.formgroup = this.betHistoryDetails;
    });
  }
  getTransactionDetails(getData,buttonId):void{
    getData.interval.start = new Date(getData.interval.start.setHours(0,0,1,0))
    getData.interval.end = new Date(getData.interval.end.setHours(23,59,59,0))
    this.betHistory = undefined;
    this.request = {
      index: getData.index ? getData.index : 0,
      size: getData.size ? getData.size :this.noOfTransactions,
      order: true,
      interval:getData.interval,
      type:"casino",
      productId:["CASINO"]
    }
    Promise.resolve(this.ajaxService.getUserBetHistory(this.request)).then(data => {
      if(buttonId){
        this.utils.enableButton(buttonId,"Filter");
      }
      this.betHistory = data?.length ? data.sort((x, y) => y.transactionTime - x.transactionTime) : [];
    },SystemError => {
      this.serverError = this.translationService.instant('errors.error6');//"Failed to get the history.Try after sometime";
      this.emitterService.broadcastserverError(this.serverError, "/myaccount/bethistory");
    });
  }

  applyFilter(buttonId,more):void{
    if(buttonId) this.utils.disableNewButton(buttonId);
    if(more === 'more'){
      this.request.index = this.request.index + this.noOfNewTransactions;
    }else if(buttonId === 'filterButton'){
      this.request.index = 0
    }else{
      this.request.index = this.request.index ? this.request.index - this.noOfNewTransactions : 0;
    }

    this.request={
      interval:{
        start:new Date(this.betHistoryDetails.controls["startDate"].value),
        end:new Date(this.betHistoryDetails.controls["endDate"].value),
      },
      size:this.noOfTransactions+"",
      index: this.request.index
    }
    this.getTransactionDetails(this.request,buttonId);
  }

  toggleAccordion(): void{
    const accordionRow = $("#mobAcc");
    const accordionHeader = accordionRow.find('.accordionHeadline');
    const accordionConent = accordionRow.find('.accordionText');

    if (!accordionConent.hasClass('activeAccordionText')) {
      $('.accordionHeadline').removeClass('flipButton');
      accordionHeader.addClass('flipButton');
      $('.accordionText').removeClass('activeAccordionText');
      accordionConent.addClass('activeAccordionText');
    }else if (accordionConent.hasClass('activeAccordionText')) {
      accordionHeader.removeClass('flipButton');
      accordionConent.removeClass('activeAccordionText');
    }
  }
  goBack(){
    // this.triggerAccountMenu.emit(true);
    this.emitterService.broadCastToggleNavPanel(true);
    this.utils.setIsSideMenuOpened(true);
  }

  ngOnDestroy(){
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
